/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PermissionScope = {
    Global: 'Global',
    Assigned: 'Assigned',
    Owner: 'Owner'
} as const;
export type PermissionScope = typeof PermissionScope[keyof typeof PermissionScope];

